import { Component, EventEmitter, OnInit, Output, ViewContainerRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { forkJoin, Observable, timer } from 'rxjs';

@Component({
    templateUrl: './ppw-game-confirm-modal.component.html',
    styleUrls: ['./ppw-game-confirm-modal.component.css']
  })

export class PledgePerWinGameConfirmModalComponent implements OnInit {

    public ready = false;
    public countdown = 5;
    public confirmInput = '';

    // Passed as initial state by game completion component
    public numberOfSubscribers: number;
    public totalChargeAmount: number;
    private parentModalRef: BsModalRef;

    @Output() submitted = new EventEmitter;

    constructor(
        private modalService: BsModalService,
        private bsModalRef: BsModalRef
    ){}

    ngOnInit(){
        timer(1000, 1000)
            .subscribe(val => {
                if (val < 6){
                    if (val === 5){
                        this.ready = true;
                    }
                    this.countdown = 5 - val;
                }
            })
    }

    saveAndClose(confirm: boolean) {
        if (this.confirmInput.toLowerCase() === 'charge subscribers' && confirm){
            this.submitted.emit(confirm);
            this.bsModalRef.hide();
        } else if (!confirm){
            this.bsModalRef.hide();
        }
    }
}